<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { EntityListPage, getDomainsLookup, type EntityConfig } from '@botto/core';
import { getCdpProjectsLookup } from '../../lookups/cdpProjects';
import { streamsStore } from '../../api';
import type { Stream } from '../../api';

const router = useRouter();
const cdpProjectsLookup = getCdpProjectsLookup();
const domainsLookup = getDomainsLookup();

onMounted(() => {
  void cdpProjectsLookup.ensureLoaded();
  void domainsLookup.ensureLoaded();
});

const config = computed<EntityConfig<Stream>>(() => ({
  title: 'Канал',
  titlePlural: 'Каналы',
  popupWidth: 600,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'name', caption: 'Название' },
    { dataField: 'system_id', caption: 'System ID', width: 160 },
    {
      dataField: 'project_id',
      caption: 'Проект',
      calculateDisplayValue: (row) => cdpProjectsLookup.labelOf(row.project_id),
    },
    {
      dataField: 'domain_id',
      caption: 'Домен',
      dataType: 'number',
      width: 180,
      calculateDisplayValue: (row) => domainsLookup.labelOf(row.domain_id),
    },
    { dataField: 'description', caption: 'Описание' },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'name', label: 'Название' },
    { dataField: 'system_id', label: 'System ID' },
    { dataField: 'project_id', label: 'Проект', lookup: cdpProjectsLookup },
    { dataField: 'domain_id', label: 'Домен', lookup: domainsLookup },
    { dataField: 'description', label: 'Описание', editorType: 'dxTextArea', colSpan: 2 },
  ],
}));

function openStream(row: Stream) {
  if (!row.id) return;
  void router.push(`/sms/streams/${row.id}`);
}
</script>

<template>
  <EntityListPage :config="config" :store="streamsStore" :on-row-dbl-click="openStream" />
</template>
